import {
  ADD_GUEST_PASS,
  REMOVE_GUEST_PASS,
  SET_CART_LOCATION,
  SET_CART_PRODUCT,
  SET_CART_PRODUCT_DEFAULT,
  SET_CART_DAYS,
  SET_CART_DATE,
  SET_CART_ACKNOWLEDGED_SOFT_CLOSE,
  RESET_CART_FORM
} from 'actions/account/cart/actionTypes'

import addGuestPass from './addGuestPass'
import removeGuestPass from './removeGuestPass'
import setCartLocation from './setCartLocation'
import setCartProduct from './setCartProduct'
import setCartProductDefault from './setCartProductDefault'
import setCartDays from './setCartDays'
import setCartDate from './setCartDate'
import setCartAcknowledgedSoftClose from './setCartAcknowledgedSoftClose'
import resetCartForm from './resetCartForm'

const cartFormReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_GUEST_PASS:
      return addGuestPass(state, action)
    case REMOVE_GUEST_PASS:
      return removeGuestPass(state, action)
    case SET_CART_LOCATION:
      return setCartLocation(state, action)
    case SET_CART_PRODUCT:
      return setCartProduct(state, action)
    case SET_CART_PRODUCT_DEFAULT:
      return setCartProductDefault(state, action)
    case SET_CART_DAYS:
      return setCartDays(state, action)
    case SET_CART_DATE:
      return setCartDate(state, action)
    case SET_CART_ACKNOWLEDGED_SOFT_CLOSE:
      return setCartAcknowledgedSoftClose(state, action)
    case RESET_CART_FORM:
      return resetCartForm(state, action)
    default:
      return state
  }
}

export default cartFormReducer
